const createMapUtils = () => {
  const createMap = (container, options = {}) => {
    const {
      zoom = 14,
      center,
      minZoom,
      maxZoom,
      draggable = true,
      scrollwheel = true,
      gestureHandling: _gestureHandling,
      disableDefaultUI: _disableDefaultUI,
      disableDoubleClickZoom: _disableDoubleClickZoom,
      mapTypeControl: _mapTypeControl,
      fullscreenControlOptions: _fullscreenControlOptions,
      zoomControl: _zoomControl,
      zoomControlOptions: _zoomControlOptions,
      padding: _padding,
      transitLayer: _transitLayer,
      showClusters: _showClusters,
      styles: _styles,
      onZoomChange: _onZoomChange,
      onIdle: _onIdle,
      onIdleFilter: _onIdleFilter,
      streetViewControl: _streetViewControl,
      mapTypeControlOptions: _mapTypeControlOptions,
      mapTypeId: _mapTypeId,
      ...rest
    } = options;

    const mapOptions = {
      container,
      style: 'mapbox://styles/mapbox/streets-v12',
      zoom,
      minZoom,
      maxZoom,
      dragPan: draggable,
      scrollZoom: scrollwheel,
      cooperativeGestures: false
    };

    if (center) {
      mapOptions.center = [
        parseFloat(center.lng || 0),
        parseFloat(center.lat || 0)
      ];
    }

    return new window.mapboxgl.Map(mapOptions);
  };

  const createLatLngBounds = () => new window.mapboxgl.LngLatBounds();

  const createLatLng = (lat, lng) => new window.mapboxgl.LngLat(lng, lat);

  return {
    createMap,
    createLatLngBounds,
    createLatLng
  };
};

export default createMapUtils;
